module.exports = __webpack_public_path__ + "img/back_closure_length.a84c51ce.png";